import React from "react";
import CheckIcon from "./CheckIcon";

/**
 * "What's included" tick list on a service page.
 * @param {string} title
 * @param {string[]} items
 */
export default function ServiceChecks({ title, items = [] }) {
    return (
        <section className="container sec-svc-list">
            <div className="svc-checks-wrap">
                <h2 className="svc-checks-title">{title}</h2>
                <div className="checks svc-checks">
                    {items.map((label) => (
                        <div className="check" key={label}>
                            <span className="tick tick--orange">
                                <CheckIcon />
                            </span>
                            <span>{label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
